import { gql } from "@apollo/client";


export const GET_CHECK_ORDER = gql`
query TotalOrderGroup($where: OrderGroupWhereInput) {
  totalOrderGroup(where: $where) {
    total
  }
}
`


export const GET_ORDER = gql`
  query Order($where: OrderWhereInputOne!) {
    order(where: $where) {
        id
        amount
        message
        phone
        addressCf
        address {
            id
            country
            province
            district
            village
            detail
            lat
            long
        }
        option
        productName
        fbMessage
        price
        totalPrice
        cfName
        isReply
      live {
            id
            page
            pageName
            detail
            description
            fbLiveId
            title
        }
        post {
            id
            page
            pageName
            fbFeedId
            detail
            description
            title
        }
        code
        liveStock {
            id
            amount
            cfMessage
            stock {
                id
                name
                amount
                optionValues {
                    id
                    name
                    value
                }
            }
        }
        postStock {
            id
            amount
            cfMessage
            stock {
                id
                name
                amount
                optionValues {
                    id
                    name
                    value
                }
            }
        }
        shop {
            id
        }
        status
        payment
        isPaymented
        user {
            id
            nickname
        }
        isDeleted
        createdAt
        updatedAt
        note
    }
}
`;

export const GET_ORDERS = gql`
query Orders(
  $where: OrderWhereInput
  $orderBy: OrderByInput
  $skip: Int
  $limit: Int
) {
  orders(where: $where, orderBy: $orderBy, skip: $skip, limit: $limit) {
    reportHistory {
      totalBill
      totalOrder
      priceLak
      priceThb
      priceUsd
    }
    total
    data {
      id
      amount
      message
      unsendMessage
      phone
      addressCf
      isReply
      isCancelled
      address {
        id
        country
        province
        district
        village
        detail
        lat
        long
      }
      option
      productName
      currency
      fbMessage
      price
      totalPrice
      cfName
      cfMessage
      tag
      tagColor
      live {
        id
        page
        pageName
        detail
        description
        fbLiveId
        title
      }
      post {
        id
        page
        pageName
        fbFeedId
        detail
        description
        title
      }
      code
      type
      liveStock {
        id
        amount
        cfMessage
        stock {
          id
          name
          amount
          currency
          image
          optionValues {
            id
            name
            value
          }
        }
      }
      postStock {
        id
        amount
        cfMessage
        stock {
          id
          name
          amount
          image
          optionValues {
            id
            name
            value
          }
        }
      }
      stocks {
        id
        name
        amount
        price
        currency
        optionValues {
          id
          name
          value
        }
      }
      orderGroup {
        id
        code
      }
      stock {
        id
        name
        amount
        price
        currency
        image
      }
      shop {
        id
        name
        phone
      }
      userConfirm {
        id
        code
        name
      }
      status
      payment
      isPaymented
      isDeleted
      createdAt
      updatedAt
      note
    }
  }
}
`;

export const GET_ORDERS_V2 = gql`
query OrdersV2(
  $where: OrderWhereInput
  $orderBy: OrderByInput
  $skip: Int
  $limit: Int
) {
  ordersV2(where: $where, orderBy: $orderBy, skip: $skip, limit: $limit) {
    reportHistory {
      totalBill
      totalOrder
      priceLak
      priceThb
      priceUsd
    }
    totalCommentsAll
    totalPsCm
    total
    data {
      id
      amount
      message
      unsendMessage
      phone
      addressCf
      isReply
      address {
        id
        country
        province
        district
        village
        detail
        lat
        long
      }
      option
      productName
      currency
      fbMessage
      price
      totalPrice
      cfName
      cfMessage
      tag
      tagColor
      live {
        id
        page
        pageName
        detail
        description
        fbLiveId
        title
      }
      post {
        id
        page
        pageName
        fbFeedId
        detail
        description
        title
      }
      code
      type
      liveStock {
        id
        amount
        cfMessage
        stock {
          id
          name
          amount
          currency
          image
          optionValues {
            id
            name
            value
          }
        }
      }
      postStock {
        id
        amount
        cfMessage
        stock {
          id
          name
          amount
          image
          optionValues {
            id
            name
            value
          }
        }
      }
      stocks {
        id
        name
        amount
        price
        currency
        optionValues {
          id
          name
          value
        }
      }
      stock {
        id
        name
        amount
        price
        currency
        image
      }
      shop {
        id
        name
        phone
      }
      userConfirm {
        id
        code
        name
      }
      status
      payment
      isPaymented
      isDeleted
      createdAt
      updatedAt
      note
    }
  }
}
`;

export const GET_ORDERGROUPS = gql`
query OrderGroups($where: OrderGroupWhereInput, $orderBy: OrderByInput, $skip: Int, $limit: Int) {
  orderGroups(where: $where, orderBy: $orderBy, skip: $skip, limit: $limit) {
    data {
      id
      amount
      totalPrice
      sumPriceBaht
      sumPriceUsd
      sumPrice
      cfName
      customerName
      customerImage
      userFbId
      code
      shipmentNumber
      invoiceStatus
      addressCf
      phone
      paySlip
      paySlips
      paymentType
      payment
      logistic
      isReply
      unsendMessage
      isClaimBalance
      isPaymentSupport
      destinationLogistic
      affiliateName
      live {
        id
        description
        pageName
      }
      post {
        id
        description
        pageName
      }
      status
      isPaymented
      type
      typeForAffiliate
      totalAffiliate
      infulancer_percent
      createdAt
      tag
      tagColor
      orders {
        id
        productName
        cfMessage
        cfName
        amount
        totalPrice
        price
        currency
        stocks {
          id
          image
          name
          price
        } 
      }
      shop {
        id
        name
        image 
        phone
      }
      infulancer {
        id
        first_name
        last_name
        phone
        status
      }
      exchangeRate {
        id
        baht
        usd
      }
      isDeleted
    }
    total
  }
}
`

export const GET_ORDERGROUPS_V2 = gql`
query OrderGroupsV2($where: OrderGroupWhereInput, $orderBy: OrderByInput, $skip: Int, $limit: Int) {
  orderGroupsV2(where: $where, orderBy: $orderBy, skip: $skip, limit: $limit) {
    total
    data {
      id
      amount
      phone
      address
      totalPrice
      sumPriceBaht
      sumPriceUsd
      sumPrice
      cfName
      customerName
      customerImage
      userFbId
      unsendMessage
      sendMessage
      tag
      tagColor
      code
      shipmentNumber
      shipPrice
      paymentType
      status
      invoiceStatus
      infulancerInvoiceStatus
      shopStatus
      payment
      isPaymented
      paySlip
      paySlips
      logistic
      originalLogistic
      destinationLogistic
      addressCf
      type
      isReply
      isDeleted
      createdAt
      updatedAt
      note
      transactionId
      infulancer_percent
      commissionAffiliate
      typeForAffiliate
      totalServiceCharge
      commissionService
      commissionInfluencer
      totalAffiliate
      isPaymentSupport
      isClaimBalance
      confirmBalance
      servicePaymentSupport
      jointOrder 
      dataConfirmCod
      live {
        id
        page
        pageName
        detail
        description
      }
      post {
        id
        page
        pageName
        description
        detail
      }
      orders {
        id
        productName
        cfMessage
        cfName
        amount
        totalPrice
        price
        currency
         stocks {
          id
          image
          name
          price
        }
        stock {
          id
          image
          name
          price
          cfMessage
          optionValues {
            id
            value
          }
        }
      }
      orderDelivery {
        id
        shop
        user
        sender {
          shopAddress
          fullName
          tel
          province
          district
          village
          branch
          branchCode
          sender_branch_id
          postcode
          address
          deliveryName
        }
        receiver {
          userAddress
          userId
          fullName
          tel
          province
          district
          village
          branch
          branchCode
          receive_branch_id
          postcode
          address
          deliveryName
        }
        status
        parcels {
          name
          detail
          size
          category
          categoryId
          dimension_length
          weight
          parcelPrice
          shippingFree
          insurance_price
          sumPrice
          width
          height
          length
        }
        match
        shipment_pay_type
        shipment_type
        parcel_type
        pieces
        orderTracking
        shipments
        deliveryTackingNo
        totalParcel
        totalShippingFree
        total
        delivery
        action
        latLong
        shipmentPayType
      }
      shop {
        id
        name
        image
        phone
      }
    }
  }
}
`

export const GET_ORDERGROUPS_DETAIL = gql`
query Query($where: OrderGroupWhereInputOne!) {
  orderGroup(where: $where) {
    id
    code
    amount
    cfName
    customerName
    userFbId
    status
    createdAt
    note
    phone
    addressCf
    shipPrice
    totalPrice
    sumPriceBaht
    sumPriceUsd
    sumPrice
    exchangeRate{
      usd
      baht
    }
    rate
    type
    isReply
    paymentType
    payment
    logistic
    destinationLogistic
    paySlip
    paySlips
    dataConfirmCod
    orders {
      id
      productName
      amount
      price
      totalPrice
      currency
      cfMessage
      cfName
      message
      createdAt 
      liveStock {
        id
        stock {
          id
          currency
          image
          optionValues {
            id
            name
            value
          }
        }
      }
      postStock {
        id
        stock {
          id
          currency
          image
          optionValues {
            id
            name
            value
          }
        }
      }
      stock {
        id
        image
        cfMessage
        amount
      }
    }
    
    live {
      id
      pageName
      page
    }
    post {
      id
      pageName
      page
    }
   
    shop {
      id
      name
      phone
      image
      address {
        village
        district
        province
      }
      isPaymentGateway
  }
    tag
    tagColor
    isPaymented
    userConfirm {
      name
      id
    }
  }
}
`;

export const GET_ORDER_GROUPS_SHOP_SETTING = gql`
  query OrderGroupShopSetting($where: OrderGroupWhereInputOne!) {
    orderGroupShopSetting(where: $where) {
      msg
      status
      dataOne {
        id
        facebook
        facebookSummary
        facebookPost
        facebookPostSummary
        post
        bank
        
        live
        logistic
        tags
        isSummaryFirst
        bankQr
        latLong
        deliveryOfPoint
        halIsOpen
        halCOD
        mxIsOpen
        mxCOD
        ansIsOpen
        ansCOD
        notifyWhatsApp
        notifyClaimBalance
        notifyPaid
        notifyDlv
        notifyDlvDestination
        notifyComplete
        createdAt
        updatedAt
        note
        phone
        isPaymentGateway
        isUseLogistics
        isLimitedOrder
        orderPoint
        isLimitetPage
        isUseSalePage
        logisticsCOD
        multipleOdFrmCm
        shop {
          id
        }
      }
      total
      tag
    }
  }
`;

export const GET_ORDER_STOCK_AMOUNT = gql`
    query Query($where: OrderWhereInputOne!) {
  order(where: $where) {
    id
    amount
    liveStock {
      id
      stock {
        id
        amount
      }
    }
    stock {
      id
      amount
    }
  }
}
`;

export const NOTICFY_ORDER_CANCEL = gql`
query NotifyOrdersCancel {
  notifyOrdersCancel {
    status
    msg
    tag
    total
  }
}`;

export const ACTIVITY_ORDERS = gql`
query ActivityOrders($where: ActivityOrderInput) {
  activityOrders(where: $where) {
    status
    msg
    tag
    total
    data {
      id
      status
      note
      orderGroupId {
        id
        sumPrice
        code
        amount
        createdAt
      }
      userId {
        firstName
        lastName
      }
    }
  }
}`;

export const ACTIVITY_ORDER = gql`
query ActivityOrder($where: ActivityOrderWhereInput!) {
  activityOrder(where: $where) {
    status
    msg
    tag
    data {
      id
      orderGroupId {
        amount
        id
        sumPrice
        totalPrice
        orders {
          productName
        }
        code
      }
      status
      userId {
        firstName
        bank {
          bankName
          bankAccountName
          bankAccountNo
          qrImage
        }
      }
      note
      shopId {
        name
      }
    }
  }
}
`;

